import { useEffect, useState } from "react";

/**
 * The current time, read only after mount and refreshed every minute.
 *
 * Returns null on the server and on the first client render. Anything that
 * depends on "now" (open or closed, which row is today) must render nothing
 * until then: the server runs in UTC and the phone anywhere, so a value
 * computed during SSR would disagree with the hydrating client and throw
 * React #418, which activity pages already hit once with a date strip.
 *
 * `fixed` pins the clock for tests.
 */
export function useVenueClock(fixed?: Date): Date | null {
  const [now, setNow] = useState<Date | null>(null);
  useEffect(() => {
    if (fixed) return;
    setNow(new Date());
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, [fixed]);
  return fixed ?? now;
}
